"use client";

import { motion, useReducedMotion } from "@/lib/motion";
import { HeroGlow } from "@/components/ui";

export default function AlternativesHero() {
  const reduced = useReducedMotion() ?? false;

  return (
    <section
      aria-labelledby="alternatives-hero-heading"
      className="border-border relative overflow-y-clip border-b pt-24 pb-[--spacing-section-sm] sm:pt-32"
    >
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <HeroGlow align="center" />
      </div>

      <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <motion.p
          initial={reduced ? false : { opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.04 }}
          className="text-brand-yellow light:text-blue-600 mb-4 text-xs font-semibold tracking-widest uppercase"
        >
          Alternatives
        </motion.p>

        <motion.h1
          id="alternatives-hero-heading"
          initial={reduced ? false : { opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.08 }}
          className="text-foreground text-4xl leading-[1.1] font-bold tracking-tight sm:text-5xl lg:text-6xl"
        >
          How Proxidize Compares
        </motion.h1>

        <motion.p
          initial={reduced ? false : { opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="text-muted-foreground light:text-foreground/80 mx-auto mt-5 mb-10 max-w-2xl text-lg leading-relaxed"
        >
          Honest, published-pricing comparisons against the other proxy providers — pricing,
          coverage, rotation, and migration, side by side.
        </motion.p>
      </div>
    </section>
  );
}
